import { APIError } from './api'

export const isApiNotFoundError = (error: unknown): error is APIError =>
  error instanceof APIError && error.statusCode === 404
